import { ImportOutlined } from '@ant-design/icons';
import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useQueryClient } from 'react-query';

import { Button } from '~/components';
import ImportLeadsModal from './ImportLeadsModal';

const ImportLeadsButton = () => {
  const { t } = useTranslation('sales');
  const [open, setOpen] = useState(false);
  const queryClient = useQueryClient();

  const handleOpen = () => setOpen(true);
  const handleClose = () => setOpen(false);

  const handleImportSuccess = () => {
    // Invalidate queries to refresh the leads list
    queryClient.invalidateQueries('my-leads');
  };

  return (
    <>
      <Button
        id="importLeadsButton"
        type="primary"
        size="middle"
        icon={<ImportOutlined />}
        onClick={handleOpen}
      >
        {t('Import Leads')}
      </Button>

      <ImportLeadsModal
        open={open}
        onClose={handleClose}
        onImportSuccess={handleImportSuccess}
      />
    </>
  );
};

export default ImportLeadsButton;
